﻿<div class="route-component">
    <div class="form-component">
        <h4 *ngIf="exchangeRateId > 0">
            Edit exchange rate
        </h4>

        <h4 *ngIf="exchangeRateId === 0">
            Create new exchange rate
        </h4>

        <form #form="ngForm" (ngSubmit)="onSave(form)">

            <div class="input-group">
                <auto-complete-dropdown
                    [options]="currencies"
                    [label]="'Currency'"
                    [placeholder]="'Select a currency...'"
                    [initialValue]="exchangeRate.currencyId"
                    [required]="true"
                    [invalid]="!exchangeRate.currencyId && formSubmitted"
                    [validationMessage]="'Currency is required'"
                    [displayWith]="displayCurrency"
                    (selectionChange)="onCurrencySelectionChange($event)">
                </auto-complete-dropdown>
            </div>

            <div class="input-group">
                <label for="date">
                    Date:<span class="required"> * </span>
                </label>
                <div>
                    <input name="date" #date ="ngModel" type="date" placeholder="yyyy-mm-dd" [class.invalid]="date.invalid" [(ngModel)]="exchangeRate.date" required>
                    <div *ngIf="date.invalid">
                        <span class="error">Date is required</span>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label for="rate">
                    Exchange Rate:<span class="required"> * </span>
                </label>
                <div>
                    <input name="rate" #rate="ngModel" type="number" placeholder="0.00" [class.invalid]="rate.invalid" [(ngModel)]="exchangeRate.value" required>
                    <div *ngIf="rate.invalid">
                        <span class="error">Rate is required</span>
                    </div>
                </div>
            </div>

            <!-- Add another rate -->
        <div class="input-group">
            <label for="addAnother">Add another rate?</label>
            <switch-control
                name="addAnother"
                [(ngModel)]="addAnother"
                label="Add another rate?">
            </switch-control>
        </div>



            <div class="action-bar">
                <button type="submit" class="button" [disabled]="form.invalid">
                    <i class="fas fa-save"></i>
                    Save
                </button>
                <button type="button" class="button-cancel" (click)=" onCancel()">
                    <i class="fas fa-cancel"></i> Cancel
                </button>
            </div>
        </form>
    </div>
</div>